import React from 'react';
import { Client } from '@ujet/websdk-headless';

import { View } from '../constants/view';
import { ChatbotWidgetOptions } from '../ChatbotWidget';

interface ChatbotWidgetContextValue {
  view: View;
  setView: (view: View) => void;
  client: Client | null;
  setClient: (client: Client) => void;
  options: ChatbotWidgetOptions;
  user: {
    name: string;
    setName: (name: string) => void;
    email: string;
    setEmail: (email: string) => void;
    phone: string;
    setPhone: (phone: string) => void;
  };
}

export const ChatbotWidgetContext = React.createContext<ChatbotWidgetContextValue>(null);
